/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module HttpPolicySetModule */

/**
 * Ajs dependency token for HTTPPolicySet item.
 */
export const HTTP_POLICY_SET_ITEM_TOKEN = 'HTTPPolicySetItem';

/**
 * Ajs dependency token for HTTPPolicySet collection.
 */
export const HTTP_POLICY_SET_COLLECTION_TOKEN = 'HTTPPolicySetCollection';

/**
 * Ajs dependency token for HTTPSecurityPolicy config item.
 */
export const HTTP_SECURITY_POLICY_CONFIG_ITEM_TOKEN = 'HTTPSecurityPolicyConfigItem';

/**
 * Ajs dependency token for HTTPSecurityRule config item.
 */
export const HTTP_SECURITY_RULE_CONFIG_ITEM_TOKEN = 'HTTPSecurityRuleConfigItem';

/**
 * Ajs dependency token for HTTPSecurityAction config item.
 */
export const HTTP_SECURITY_ACTION_CONFIG_ITEM_TOKEN = 'HTTPSecurityActionConfigItem';

/**
 * Ajs dependency token for HTTPRedirectAction config item.
 */
export const HTTP_REDIRECT_ACTION_CONFIG_ITEM_TOKEN = 'HTTPRedirectActionConfigItem';

/**
 * Ajs dependency token for RateLimiterAction config item.
 */
export const RATE_LIMITER_ACTION_CONFIG_ITEM_TOKEN = 'RateLimiterActionConfigItem';

/**
 * Ajs dependency token for HTTPRequestPolicy config item.
 */
export const HTTP_REQUEST_POLICY_CONFIG_ITEM_TOKEN = 'HTTPRequestPolicyConfigItem';

/**
 * Ajs dependency token for HTTPRequestRule config item.
 */
export const HTTP_REQUEST_RULE_CONFIG_ITEM_TOKEN = 'HTTPRequestRuleConfigItem';

/**
 * Ajs dependency token for HTTPRewriteURLAction config item.
 */
export const HTTP_REWRITE_URL_ACTION_CONFIG_ITEM_TOKEN = 'HTTPRewriteURLActionConfigItem';

/**
 * Ajs dependency token for HTTPSwitchingAction config item.
 */
export const HTTP_SWITCHING_ACTION_CONFIG_ITEM_TOKEN = 'HTTPSwitchingActionConfigItem';

/**
 * Ajs dependency token for HTTPHdrAction config item.
 */
export const HTTP_HDR_ACTION_CONFIG_ITEM_TOKEN = 'HTTPHdrActionConfigItem';

/**
 * Ajs dependency token for HTTPHdrData config item.
 */
export const HTTP_HDR_DATA_CONFIG_ITEM_TOKEN = 'HTTPHdrDataConfigItem';

/**
 * Ajs dependency token for HTTPResponsePolicy config item.
 */
export const HTTP_RESPONSE_POLICY_CONFIG_ITEM_TOKEN = 'HTTPResponsePolicyConfigItem';

/**
 * Ajs dependency token for HTTPResponseRule config item.
 */
export const HTTP_RESPONSE_RULE_CONFIG_ITEM_TOKEN = 'HTTPResponseRuleConfigItem';

/**
 * Ajs dependency token for HTTPRewriteLocHdrAction config item.
 */
export const HTTP_REWRITE_LOC_HDR_ACTION_CONFIG_ITEM_TOKEN = 'HTTPRewriteLocHdrActionConfigItem';
